module.exports = "<nm-page-header header=\"Dashboard\"></nm-page-header>"


//////////////////
// WEBPACK FOOTER
// ./src/pages/dashboard/dashboard.html
// module id = 503
// module chunks = 0